import { render, staticRenderFns } from "./OauthAdditionalDetails.vue?vue&type=template&id=a620e4a0"
import script from "./OauthAdditionalDetails.vue?vue&type=script&lang=js"
export * from "./OauthAdditionalDetails.vue?vue&type=script&lang=js"
import style0 from "./OauthAdditionalDetails.vue?vue&type=style&index=0&id=a620e4a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports